/*
 * Copyright (c) Dito Technologies LLC
 */

const ItemTypes = {
    NOTE: 'note'
};

export interface NoteItem {
    bulbId: string;
    midiNumber: number;
    noteDuration: number;
    noteStart: number;
}

export default ItemTypes;
